var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSteezyClassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4712 18.6211H13.8462C11.3368 18.6211 9.28369 20.6742 9.28369 23.1836V50.5586C9.28369 53.068 11.3368 55.1211 13.8462 55.1211H59.4712C61.9806 55.1211 64.0337 53.068 64.0337 50.5586V23.1836C64.0337 20.6742 61.9806 18.6211 59.4712 18.6211ZM59.4712 50.5586H13.8462V23.1836H59.4712V50.5586Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6274 45.9961C53.8873 45.9961 54.9087 44.9747 54.9087 43.7148C54.9087 42.4549 53.8873 41.4336 52.6274 41.4336C51.3675 41.4336 50.3462 42.4549 50.3462 43.7148C50.3462 44.9747 51.3675 45.9961 52.6274 45.9961Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5024 45.9961C44.7623 45.9961 45.7837 44.9747 45.7837 43.7148C45.7837 42.4549 44.7623 41.4336 43.5024 41.4336C42.2425 41.4336 41.2212 42.4549 41.2212 43.7148C41.2212 44.9747 42.2425 45.9961 43.5024 45.9961Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6587 41.4336H18.4087V45.9961H36.6587V41.4336Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteezyClassIcon);
export default __webpack_public_path__ + "static/media/steezy-class-icon.b0c5bcbe.svg";
export { ForwardRef as ReactComponent };